import { TableCell, TableHead, TableRow } from '@mui/material';
import React, { memo } from 'react';

function DocumentsTableHead() {
  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
        <TableCell sx={{ width: { xs: '200px', sm: '40%' }, minWidth: '150px', fontWeight: 600 }}>
          Name
        </TableCell>
        <TableCell sx={{ width: { xs: '150px', sm: '20%' }, minWidth: '120px', fontWeight: 600 }}>
          Upload Date
        </TableCell>
        <TableCell sx={{ width: { xs: '150px', sm: '20%' }, minWidth: '120px', fontWeight: 600 }}>
          Uploaded By
        </TableCell>
        <TableCell
          sx={{ width: { xs: '150px', sm: '20%' }, minWidth: '120px', pr: 3.5, fontWeight: 600 }}
          align="right"
        >
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default memo(DocumentsTableHead);
